import styled from "styled-components";
import logo from "./icons/gleamer-logo.svg";

export const Logo = styled.img.attrs({
  src: logo,
  alt: "Gleamer",
})`
  width: min(23rem, 80vw);
`;
